export const LICENSE_CARD_HEADER = 'Set up your licenses'
export const LICENSE_CARD_TEXTLINK = 'Assign Licenses'
export const UNASSIGNED_LICENSES = unassignedLicensesCount => {
  return `${unassignedLicensesCount} ${
    unassignedLicensesCount > 1 ? 'licenses are' : 'license is'
  } unassigned to a school`
}
